module.exports = __webpack_public_path__ + "static/media/addEvidenceHover.4bf9a141.png";